export function addPageAction<Type>(key: string, data?: Type | undefined) {
  if (!data) {
    window?.newrelic?.addPageAction(key);
  } else {
    window?.newrelic?.addPageAction(key, data);
  }
}
